<template>
  <json-excel
    class="btn btn-kne-orange pull-right"
    :data="JSON.parse(JSON.stringify(filterResultsWithOrder))"
    :fields="customerFields"
    :name="name">
      <!-- <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>-->
      {{$t('OrderCurrent.modal.billing.generate_excel_sheet')}}
  </json-excel>
</template>

<script>
import JsonExcel from 'vue-json-excel'

export default {
  name: 'CustomJsonExcel',
  components: {
    JsonExcel
  },

  props: {
    name: {
      type: String,
      required: true
    },
    customerFields: {
      type: Object,
      required: true
    },
    filterResults: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
    }
  },
  created () {
    this.filterResultsWithOrder
  },
  methods: {
    getDate: function (timestamp) {
      let date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  },
  computed: {
    filterResultsWithOrder () {
      let newArray = []

      this.filterResults.forEach((element) => {
        let newEle = element
        newEle.order = element['.key']
        newArray.push(element)
      })

      newArray.reverse()
      return newArray
    }
  }
}
</script>

<style>

</style>
